import { useEffect, useState } from 'react';
import { groupTripApi } from '../../api/groupTripApi';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { lateJoinTimelineLabel } from './groupTripLateJoinModel';

function eventLabel(t, item, hostMemberId) {
  const lateJoin = lateJoinTimelineLabel(item, t, hostMemberId);
  if (lateJoin != null) return lateJoin;
  if (item.eventType === 'ACTIVITY_ADDED') return t('travel.groupTrip.runtimeAdded');
  if (item.eventType === 'ACTIVITY_CANCELLED') return t('travel.groupTrip.runtimeCancelled');
  if (item.eventType === 'ACTIVITY_REPLACED') return t('travel.groupTrip.runtimeReplaced');
  if (item.eventType === 'ACTIVITY_TIME_CHANGED') return t('travel.groupTrip.runtimeTimeChanged');
  if (item.eventType === 'TRAVELER_PARTICIPATION_CHANGED') return t('travel.groupTrip.runtimeParticipation');
  return item.eventType;
}

function detail(item) {
  if (item.beforeValue && item.afterValue) return `${item.beforeValue} → ${item.afterValue}`;
  if (item.fromState && item.toState) return `${item.fromState} → ${item.toState}`;
  return item.afterValue || item.beforeValue || '';
}

export default function GroupTripRuntimeTimeline({ groupTripId, hostMemberId = null }) {
  const { t } = useTravelTranslation();
  const [planned, setPlanned] = useState([]);
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!groupTripId || typeof groupTripApi.readRuntimeTimeline !== 'function') return undefined;
    let cancelled = false;
    groupTripApi.readRuntimeTimeline(groupTripId)
      .then((payload) => {
        if (cancelled) return;
        const body = payload?.data || payload || {};
        setPlanned(Array.isArray(body.plannedActivities) ? body.plannedActivities : []);
        setItems(Array.isArray(body.items) ? body.items : []);
        setLoaded(true);
      })
      .catch(() => {
        if (!cancelled) {
          setPlanned([]);
          setItems([]);
          setLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [groupTripId]);

  if (!loaded) return null;
  const empty = planned.length === 0 && items.length === 0;

  return (
    <section className="group-trips__panel" data-testid="group-trip-runtime-timeline">
      <h2>{t('travel.groupTrip.runtimeTimelineTitle')}</h2>
      {empty ? <p className="group-trips__hint">{t('travel.groupTrip.runtimeEmpty')}</p> : null}
      {planned.length > 0 ? (
        <div>
          <h3>{t('travel.groupTrip.runtimePlannedTitle')}</h3>
          <ul className="group-trips__list">
            {planned.map((activity) => (
              <li className="group-trips__card" key={activity.activityId}>{activity.title}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {items.length > 0 ? (
        <div>
          <h3>{t('travel.groupTrip.runtimeChangedTitle')}</h3>
          <ul className="group-trips__list">
            {items.map((item) => (
              <li className="group-trips__card" key={item.eventId} data-testid={`runtime-event-${item.eventId}`}>
                <p>{eventLabel(t, item, hostMemberId)}</p>
                {detail(item) ? <p>{detail(item)}</p> : null}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
}
